// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"810":"4c30d9e5","1559":"5c0b2e3b","1623":"8bac97d8","2118":"5c0b2e3b","3942":"4877ddcf","6034":"5c0b2e3b","8366":"4877ddcf","9957":"4877ddcf"}[chunkId] + ".chunk.css";
};